import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export default function FAQSection() {
  return (
    <section className="py-24 bg-white">
      <div className="landing-container">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h3 className="text-lg font-medium text-gray-500 mb-2">FAQ</h3>
          <h2 className="text-4xl font-bold text-gray-900">Perguntas Frequentes</h2>
        </div>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            <AccordionItem value="item-1">
              <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:no-underline">
                O Culture Monitor é uma ferramenta automatizada ou tem análise humana?
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed">
                Combinamos tecnologia de monitoramento em tempo real com uma rede de agentes culturais humanos, garantindo leitura contextual e sensibilidade cultural que plataformas 100% automatizadas não oferecem.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-2">
              <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:no-underline">
                O que diferencia o Culture Monitor de outras plataformas de social listening?
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed">
                Em vez de apenas dashboards, o Culture Monitor identifica comportamentos, territórios culturais, comunidades e criadores. Os insights são entregues interpretados e acionáveis, com foco em performance.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-3">
              <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:no-underline">
                Com que frequência recebo os insights?
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed">
                Diariamente. Você recebe relatórios e alertas com oportunidades culturais mapeadas em tempo real.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-4">
              <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:no-underline">
                Como o Culture Monitor se integra à minha operação?
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed">
                Oferecemos consultoria personalizada para guiar a melhor configuração de processo, integração com times e governança mais ágil, garantindo que os insights se transformem em ação rapidamente.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-5">
              <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:no-underline">
                O Culture Monitor é exclusivo para clientes da LIVE?
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed">
                Não. O produto pode ser contratado por qualquer marca, independentemente de quem executa suas campanhas. Se desejar, também oferecemos acesso aos times criativos e de creators da LIVE.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-6">
              <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:no-underline">
                Posso monitorar regiões, comunidades ou creators específicos?
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed">
                Sim. A leitura é personalizada por território, nicho, comunidade ou influenciador, baseada nos objetivos estratégicos da sua marca.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </section>
  );
}

